module.exports = __webpack_public_path__ + "static/media/Header_Image.e0b42b9a.png";